import {
  SENDING_GROUPS_REQUEST,
  FETCH_GROUPS_SUCCESS,
  FETCH_GROUPS_FAILURE,
  SENDING_GROUP_CREATE,
  //CREATE_GROUP_SUCCESS,
  CREATE_GROUP_FAILURE,
  SENDING_GROUP_UPDATE,
  //UPDATE_GROUP_SUCCESS,
  UPDATE_GROUP_FAILURE,
  SENDING_GROUP_DELETE,
  //DELETE_GROUP_SUCCESS,
  DELETE_GROUP_FAILURE
} from '../actions/constants'

const initialState = {
  groups: [],
  treeGroups: [],
  fetching: false,
  error: ''
}

const group = (state = initialState, action) => {
  switch (action.type) {
    case SENDING_GROUPS_REQUEST:
    case SENDING_GROUP_CREATE:
    case SENDING_GROUP_UPDATE:
    case SENDING_GROUP_DELETE:
      return {
        ...state,
        fetching: action.sending
      }
    case FETCH_GROUPS_SUCCESS:
      return {
        ...state,
        groups: action.groups,
        treeGroups: action.treeGroups
      }
    case FETCH_GROUPS_FAILURE:
    case CREATE_GROUP_FAILURE:
    case UPDATE_GROUP_FAILURE:
    case DELETE_GROUP_FAILURE:
      return {
        ...state,
        error: action.error
      }
    default:
      return state
  }
}

export default group



// WEBPACK FOOTER //
// ./src/reducers/group.js